import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doctor2_diagnosis-enter-disease-xiaohua",
  "use": "icon-doctor2_diagnosis-enter-disease-xiaohua-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 22\" id=\"icon-doctor2_diagnosis-enter-disease-xiaohua\">\r\n  <g transform=\"translate(-669 -367)\">\r\n    <path class=\"a\" d=\"M85.676,99.11c-5.066-2.394-8.929,4.116-8.853.874a2.035,2.035,0,0,0-.469-1.507,1.019,1.019,0,0,0-1.71.443,3.759,3.759,0,0,0,2.292,4.9c4.04,1.621,2.216,7.27-.583,8.612-3.749,1.8-2.875-1.469-4.977-1.71-.9-.1-2.723.165-3.255,2.862-.291,1.444-.633,2.508.114,2.761,2.356.785.621-4.547,3.356-3.432,1.988.811,1,4.344,5.446,5.509C86.082,120.781,95.277,103.632,85.676,99.11Zm-.519,14.641c-1.343,1.52-3.445,3.331-5.864,3.331h-.076a4.153,4.153,0,0,1-2.457-.785.378.378,0,0,1,.481-.583c.127.1,3.1,2.368,7.346-2.457a.38.38,0,0,1,.532-.038A.367.367,0,0,1,85.157,113.752Z\" transform=\"translate(601.246 269.594)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/doctor2_diagnosis-enter-disease-xiaohua.svg
// module id = zy3N
// module chunks = 10